/* eslint-disable @typescript-eslint/ban-ts-comment */
import { MyRootBlock } from '../plateTypes';
import { ArticleStructure } from './types';

/**
 * Convert to the latest version of the article structure. Currently this only
 * converts from 1.0.0 to 1.1.0 but in the future it will cover more formats.
 *
 * @param oldStructure
 * @returns New article structure
 */
export function transformArticleStructure(
  oldStructure: ArticleStructure,
): ArticleStructure {
  return {
    version: '1.3.0',
    children: oldStructure.children.map(transformBlock),
  };
}

function transformBlock(oldBlock: { type: string } & MyRootBlock): MyRootBlock {
  switch (oldBlock.type) {
    // @ts-ignore
    case 'paragraph':
      return {
        // @ts-ignore
        ...oldBlock,
        type: 'p',
      };

    // @ts-ignore
    case 'heading_large':
      return {
        // @ts-ignore
        ...oldBlock,
        type: 'h_lg',
      };

    // @ts-ignore
    case 'heading_medium': {
      return {
        // @ts-ignore
        ...oldBlock,
        type: 'h_md',
      };
    }

    // @ts-ignore
    case 'heading_small': {
      return {
        // @ts-ignore
        ...oldBlock,
        type: 'h_sm',
      };
    }

    // @ts-ignore
    case 'divider': {
      return {
        // @ts-ignore
        ...oldBlock,
        type: 'hr',
      };
    }

    // @ts-ignore
    case 'codeblock': {
      return {
        // @ts-ignore
        ...oldBlock,
        type: 'code_block',
      };
    }
  }
  return oldBlock;
}
